import emissionViewStore from "../../../../Store/marco/emissionViewStore";
import { emissionFactorAPI } from "../../../API/emissionFactorAPI";
export async function EFUnitValidation(data, landData, target, cat) {
  const {
    _handleSetEFCheckId,
    _handleSetEmissionActivityModalLoading,
    _handleSetLandEFCheckId,
  } = emissionViewStore;
  const { modifyEFCheck } = emissionFactorAPI;

  if (target === "EFLandFormData") {
    if (!data.id || !data.landEFTypeId || !data.landEFId) return;
  } else {
    if (!data.id || !data.emissionFactorTypeId || !data.emissionFactorId)
      return;
  }

  _handleSetEFCheckId(null);
  const requestBody = {
    id: data?.id,
    isTransport4_3: data.landEFId ? true : false,
    emissionFactorTypeId:
      target === "EFLandFormData"
        ? data.landEFTypeId
        : data?.emissionFactorTypeId,
    emissionFactorId:
      target === "EFLandFormData" ? data.landEFId : data?.emissionFactorId,
  };
  const checkEF = async () => {
    _handleSetEmissionActivityModalLoading(true);
    try {
      const response = await modifyEFCheck(cat, requestBody);
      if (response === false) {
        //////// 4_3 運輸
        if (target === "EFLandFormData") {
          _handleSetLandEFCheckId(true);
        } else {
          _handleSetEFCheckId(data.id);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      _handleSetEmissionActivityModalLoading(false);
    }
  };

  checkEF();
}
